import { render, staticRenderFns } from "./ExcludedParts.vue?vue&type=template&id=b4f8883c&scoped=true"
import script from "./ExcludedParts.vue?vue&type=script&lang=js"
export * from "./ExcludedParts.vue?vue&type=script&lang=js"
import style0 from "./ExcludedParts.vue?vue&type=style&index=0&id=b4f8883c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f8883c",
  null
  
)

export default component.exports